import { Component, Injector, OnInit } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { TermsMaintenanceService } from '../../service/terms-maintenance.service';
import { TIMEOUT } from 'dns';
import { timeout } from 'rxjs/operators';

@Component({
  selector: 'laas-terms-view',
  templateUrl: './terms-view.component.html',
  styleUrls: ['./terms-view.component.scss']
})
export class TermsViewComponent extends SessionBaseComponent  implements OnInit {

  showContent: string='';
  laasTermsContent: string='';
  privateTermsContent: string='';
  cookieTermsContent: string='';
  customerNotificationContent: string= '';
  updateDt: string='';
  termsTypeOptions: any[] = [];
  browserLanguage: string='';
  selectedTermsType: string='';

  constructor(
    injector: Injector,
    private termsMaintenanceService: TermsMaintenanceService
  ) {
    super(injector);

    setTimeout(() => {
      this.termsTypeOptions = [
        { label: this.translateService.instant('Terms.View.LaaSTerms'), value: 'laasTerms' },
        { label: this.translateService.instant('Terms.View.CookiePolicy'), value: 'cookieTerms' },
        { label: this.translateService.instant('Terms.View.PrivacyPolicy'), value: 'privateTerms' },
        { label: this.translateService.instant('Terms.View.CustomerNotification'), value: 'customerNotification' }
      ];

      this.selectedTermsType = this.termsTypeOptions[0].value;
    }, 500);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.browserLanguage = navigator.language.toLowerCase();

    var Obj: any = {
      termsContent: "",
      termsTitle: '',
      uuid: '',
      createUser: '',
      language : this.browserLanguage,
      status:'A'
    };

    this.termsMaintenanceService.getTerms(Obj).subscribe({
      next: result => {
        this.laasTermsContent = result.laasTermsContent;
        this.privateTermsContent = result.privateTermsContent;
        this.cookieTermsContent = result.cookieTermsContent;
        this.customerNotificationContent = result.customerNotificationContent;
        this.updateDt = result.updateDt;

        this.showContent = this.laasTermsContent
      }
    });

  }

  typeChange(event: any){
   this.selectedTermsType = event.value;

   if(event.value == 'laasTerms'){
    this.showContent = this.laasTermsContent
   }

   if(event.value == 'cookieTerms'){
    this.showContent = this.cookieTermsContent
   }

   if(event.value == 'privateTerms'){
    this.showContent = this.privateTermsContent
   }

   if(event.value == 'customerNotification'){
    this.showContent = this.customerNotificationContent
   }

  }

}
